var render = function render(_c,_vm){return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48","aria-hidden":"true","fill":"currentColor"}},[_c('path',{attrs:{"d":"m23.999 35.882-1.2-1.053L.612 15.285a1.805 1.805 0 0 1-.162-2.554 1.8 1.8 0 0 1 2.548-.162l21 18.491 21-18.491a1.807 1.807 0 0 1 2.552.162 1.809 1.809 0 0 1-.161 2.554Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }